import * as React from "react";

import "./with-enrollment.scss";

import {ReactGASCEnrollment} from "@Common/libs/ga/xd-react-ga";
import {cs}                  from "@Common/react/chain-services";
import {fragments}           from "@Common/react/fragments";
import {Invoke}              from "@Common/react/invoke";
import {Static2}             from "@Common/react/static-2";
import {chain}               from "@Common/utils/fs";

import {saveStepUrl}     from "../common/save-step-url";
import {urlStepNames}    from "../common/url-step-names";
import {SetupModal}      from "../setup-modal/setup-modal";
import {EnrollmentSteps} from "../steps/enrollment-steps";

import {EditionsDashboard} from "./editions-dashboard/editions-dashboard";
import {Preferences}       from "./preferences/preferences";

export const WithEnrollment = (
    {
        enrollment, initStep, agentId, branchId, program, getStyleTemplate,
        saveEnrollment, next: rootNext,
    }
) => cs(

    ["block", (_, next) => Static2({next})],
    ({block}, next) => rootNext({
        navBlock: {
            block: () => block.get()?.(),
        },
        render: () => next(),
    }),



    ["initStep", (_, next) => next(chain(
        urlStepNames.indexOf(initStep),
        (_) => _ === -1 ? null : _,
    ))],

    ["setupModal", ({initStep, block}, next) => cs(
        ["setupModal", (_, next) => SetupModal({
            enrollment, agentId, branchId, program,
            ...initStep!=null && {
                initShow: {tab: initStep},
            },
            setNavBlock: block.set,
            onShowStep: (stepIndex) => saveStepUrl(urlStepNames[stepIndex]),
            saveEnrollment: async (newValue, options) => {
                ReactGASCEnrollment({
                    eventName: "modify_enrollment",
                    idProgram: program.idProgram,
                });

                return await saveEnrollment(newValue, options);
            },
            getStyleTemplate,
            next,
        })],
        ({setupModal}) => next({
            ...setupModal,
            show: (params) => {
                ReactGASCEnrollment({
                    eventName: "view_enrollment",
                    idProgram: program.idProgram,
                });

                return setupModal.show({
                    ...params,
                });
            },
        }),
    )],

    ["steps", (_, next) => EnrollmentSteps({
        initEnrollment: enrollment,
        getStyleTemplate,
        agentId, branchId, program,
        next,
    })],

    ({}, next) => fragments(
        next(),
        Invoke({
            action: () => {
                saveStepUrl("dashboard");
            },
        })
    ),
    ({steps, setupModal,}) => (
        <div className="with-enrollment-9nf">
            {Preferences({
                steps,
                setupModal,
                className: "section",
            })}

            {EditionsDashboard({
                className: "section",
                program,
                enrollment,
                agentId,
                getStyleTemplate,
                saveEnrollment,
            })}
        </div>
    ),
);

